import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
import { fetchWeeklyPosts, fetchInStockAgainProducts, fetchRecommendedForYouProducts, getActionProductsList, getLastProductsList } from '../../redux/actions/productActions';

import BlockActionSliderContent from "./BlockActionSliderContent";
import globalVariable from '../../global';
import { useTranslation } from 'react-i18next';
import LoaderMaskSlider from '../other/LoaderMaskSlider';
import SmartLink from '../../components/SmartLink';

const BlockActionSliderImage = (props) => {
    const params = useParams();
    const dispatch = useDispatch();
    const { productId } = params;

    const getRelatedSale = useSelector((state) => state.getProductRelatedSale);
    const getRelatedProducts = useSelector((state) => state.getRelatedCategoryProducts);
    const weeklyProducts = useSelector((state) => state.weeklyProducts.items);
    const inStockAgainProducts = useSelector((state) => state.inStockAgainProducts.items);
    const recommendedProducts = useSelector((state) => state.recommendedProducts.items);
    const getLastProducts = useSelector((state) => state.getLastProducts);
    const getB2bSettings = useSelector((state) => state.getB2bSettings);
    const mainPageBlockOrder = getB2bSettings?.items?.acMainPageBlockOrder ? getB2bSettings.items.acMainPageBlockOrder : {};

    const { t } = useTranslation('block');
    var items = [];
    var link = "";

    const [isBannerImage, setIsBannerImage] = useState(0);
    const [slidesToShow, setSlidesToShow] = useState(4);
    const [slidesToScroll, setSlidesToScroll] = useState(4);
    const [loading, setLoading] = useState(true);
    const [subMenu, setSubMenu] = useState([]);

    const getUserBanner = useSelector((state) => state.getUserBanner.items);
    const bennerListItems = getUserBanner.filter((x) => x.anPageKey === 251);
    const bennerList = bennerListItems.filter((x) => x.anBannerKey === props.position);



    // Uvedena provera jer se struktura podatka za meni razlikuje u zavisnosti od jezika - Ivan 10.10.2024.
    // const currentLanguage = useMemo(() => document.documentElement.lang ? document.documentElement.lang : 'en', []);
    const getMenuItems = useSelector((state) => state.menuItems);
    const menuItemsPosition = getMenuItems && getMenuItems.filter(x => x.position === 1)

    // const subMenu = menuItemsPosition ? menuItemsPosition[0].menu[1].subMenu.filter(x => x.acMenu === props.title) : [];
    // const subMenu = [];
    useEffect(() => {
        const menuItemsPosition = getMenuItems && getMenuItems.filter(x => x.position === 1)
        setSubMenu(menuItemsPosition ? menuItemsPosition[0]?.menu[1]?.subMenu.filter(x => x.acMenu === props.title) : []);
    }, [getMenuItems, props.title]);
    useEffect(() => {
        setLoading(true);
        if (bennerList[0]) {
            setIsBannerImage(1);
            setSlidesToShow(5);
            setSlidesToScroll(5);
        } else {
            setIsBannerImage(0);
            setSlidesToShow(7);
            setSlidesToScroll(7);
        }

        async function fetchData() {
            if (props.type === mainPageBlockOrder.anSpecialActionId1) {
                await dispatch(getActionProductsList(mainPageBlockOrder.anSpecialActionId1, 'currentAction'));
            } else if (props.type === mainPageBlockOrder.anSpecialActionId2) {
                await dispatch(getActionProductsList(mainPageBlockOrder.anSpecialActionId2, 'inStockAgain'));
            } else if (props.type === mainPageBlockOrder.anSpecialActionId3) {
                await dispatch(getActionProductsList(mainPageBlockOrder.anSpecialActionId3, 'recommendedForYou'));
            } else if (props.type === 'viewedProducts') {
                await dispatch(getLastProductsList());
            }
            setLoading(false);
        }
        // Fetch data based on the type prop
        fetchData();

    }, [dispatch, props.type]);
    // useEffect(() => {
    //     const allItemsForSlider = [
    //         ...(getRelatedSale || []),
    //         ...(getRelatedProducts || []),
    //         ...(weeklyProducts || []),
    //         ...(inStockAgainProducts || []),
    //         ...(recommendedProducts || []),
    //         ...(getLastProducts?.items || [])
    //     ];

    //     const totalLength = allItemsForSlider.length;

    //     if (totalLength > 0) {
    //         setLoading(false);
    //     }
    // }, [
    //     getRelatedSale,
    //     getRelatedProducts,
    //     weeklyProducts,
    //     inStockAgainProducts,
    //     recommendedProducts,
    //     getLastProducts
    // ]);

    if (props.type == "relatedSale") {
        items = getRelatedSale;

    } else if (props.type == "relatedProducts") {
        const productsArray = getRelatedProducts.slice(0, 10);
        items = productsArray.filter((el) => el.anProductKey !== productId);
        // link = getMenuItems ? getMenuItems.menu[1].subMenu[11].acLink : "";

    } else if (props.type == mainPageBlockOrder.anSpecialActionId1) {
        items = weeklyProducts;
    } else if (props.type == mainPageBlockOrder.anSpecialActionId2) {
        items = inStockAgainProducts;
    } else if (props.type == mainPageBlockOrder.anSpecialActionId3) {
        items = recommendedProducts;
    } else if (props.type == 'viewedProducts') {
        items = getLastProducts.items;
        // link = getMenuItems ? getMenuItems.menu[1].subMenu[11].acLink : "";

    }


    var imageClassName = '';
    var blockItemsClassName = '';
    if (props.isHomepage == 'true') {
        imageClassName = 'homepage-content-special-image-block';
        blockItemsClassName = 'homepage-special-block-items';

    } else {
        imageClassName = 'content-special-image-block';
        blockItemsClassName = 'special-block-items';
    }

    return (
        <>
            {bennerList[0] ? (
                props.type == mainPageBlockOrder.anSpecialActionId3
                    ? <SmartLink to={bennerList[0].acBannerLink} isNewTabOpen={bennerList[0].isNewTabOpen}>
                        <div className={imageClassName}>
                            <div className="action-block-special-banner-background-wrapper" style={{ overflow: 'hidden' }}>
                                <div className="action-block-special-banner-bacground" title={bennerList[0].acSeoTitle} style={{ background: `url(${globalVariable.imagesPath}/media/${bennerList[0].acBannerImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}></div>
                                <img src={`${globalVariable.imagesPath}/media/${bennerList[0].acBannerImage}`} className="img-fluid action-block-special-banner-image" alt={`${bennerList[0].acSeoDescription}`} title={`${bennerList[0].acSeoTitle}`} />
                            </div>
                            <div className="special-block-image-mask">
                                <div className="special-block-image-mask-content">
                                    <div className="special-block-image-mask-name">{bennerList[0].acBannerTitle}</div>
                                    <div className="special-block-image-mask-btn">
                                        <div className="special-block-image-mask-btn-item">
                                            {
                                                props.type == mainPageBlockOrder.anSpecialActionId3
                                                    ? <SmartLink to={bennerList[0].acBannerLink} isNewTabOpen={bennerList[0].isNewTabOpen}>{t('prijaviSe')}</SmartLink>
                                                    : <SmartLink to={bennerList[0].acBannerLink} isNewTabOpen={bennerList[0].isNewTabOpen}>{t('detaljnije')}</SmartLink>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SmartLink>
                    : <SmartLink to={bennerList[0].acBannerLink} isNewTabOpen={bennerList[0].isNewTabOpen}>
                        <div className={imageClassName}>
                            <div className="action-block-special-banner-background-wrapper" style={{ overflow: 'hidden' }}>
                                <div className="action-block-special-banner-bacground" title={bennerList[0].acSeoTitle} style={{ background: `url(${globalVariable.imagesPath}/media/${bennerList[0].acBannerImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}></div>
                                <img src={`${globalVariable.imagesPath}/media/${bennerList[0].acBannerImage}`} className="img-fluid action-block-special-banner-image" alt={`${bennerList[0].acSeoDescription}`} title={`${bennerList[0].acSeoTitle}`} />
                            </div>
                            <div className="special-block-image-mask">
                                <div className="special-block-image-mask-content">
                                    <div className="special-block-image-mask-name">{bennerList[0].acBannerTitle}</div>
                                    <div className="special-block-image-mask-btn">
                                        <div className="special-block-image-mask-btn-item">
                                            {
                                                props.type == mainPageBlockOrder.anSpecialActionId3
                                                    ? <SmartLink to={bennerList[0].acBannerLink} isNewTabOpen={bennerList[0].isNewTabOpen}>{t('prijaviSe')}</SmartLink>
                                                    : <SmartLink to={bennerList[0].acBannerLink} isNewTabOpen={bennerList[0].isNewTabOpen}>{t('detaljnije')}</SmartLink>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </SmartLink>

            ) : (
                props.isHomepage == 'true' ?
                    <div className={imageClassName}>
                        <div className="action-block-special-banner-background-wrapper" style={{ overflow: 'hidden' }}>
                            <div className="action-block-special-banner-bacground" title="Specijalna akcija" style={{ background: "url(./no-image-actions-banners.png)", backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}></div>
                            <img src="/no-image-actions-banners.png" alt="Placeholder" className="img-fluid action-block-special-banner-image" />
                        </div>
                    </div>
                    :
                    ""
            )}

            <div className={blockItemsClassName}>
                <div className="special-block-title-main">
                    <SmartLink to={props.link} isNewTabOpen={props.isNewTabOpen} className="link">
                        <h2>{props.title}</h2>
                    </SmartLink>
                </div>

                <div className="content-slider-special-action">
                    {loading ? (
                        <div className="loyalty-msg-holder">
                            <div className="loading-block">
                                <LoaderMaskSlider />
                            </div>
                        </div>
                    ) : (
                        items && items.length > 0 ? (
                            <BlockActionSliderContent
                                isHomepage={props.isHomepage}
                                items={items}
                                isBannerImage={isBannerImage}
                                slidesToShow={slidesToShow}
                                slidesToScroll={slidesToScroll}
                                type={props.type}
                                productId={productId}
                            />
                        ) : (
                            <div className="alert alert-danger w-100" role="alert">
                                {t('nemaAktivnihProizvoda')}
                            </div>
                        )
                    )}

                </div>


            </div>
        </>
    );
};

export default BlockActionSliderImage;
